import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Grid } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import DrawerMenu from './DrawerMenu';
import Home from './Home.page';
import Users from '../users/Users.page';
import Stores from '../stores/Stores.page';
import User from '../users/UserDetails.page';
import Priorities from '../priorities/Priorities.page';
import LoginPage from '../auth/Login.page';
import { UserContext } from '../auth/User.context';
import Unauthorized from '../auth/Unauthorized.page';
import SpinningSpark from '../shared/components/SpinningSpark';
import StoreDetails from '../stores/StoreDetails.page';
import POTD from '../potd/POTD.page';
import POTDCreate from '../potd/POTDCreate.page';
import POTDCandidates from '../potd/POTDCandidates.page';
import POTDEdit from '../potd/POTDEdit.page';
import AccessControl from './AccessControl';
import VideoReviewDashboard from '../videoReviewDashboard/videoReviewDashboard.page';
import PowerBI from '../reports/PowerBI.page';
import Stickers from '../stickers/Stickers.page';
import SocialChamps from '../socialChamps/SocialChamps.page';
import Templates from '../templates/Templates.page';
import TemplateFormPage from '../templates/TemplateForm.page';
import StorePhotosReview from '../storePhotosReview/StorePhotosReview.page';
import TasksPage from '../tasks/Tasks.page';
import TaskFormPage from '../tasks/TaskForm.page';
import AlertsPage from '../alerts/Alerts.page';
import AlertFormPage from '../alerts/AlertForm.page';
import Guide from '../guide/Guide.page';
import FileUpload from '../fileUpload/FileUpload.page';

const AuthenticatedRoutes = ({
  userPermissions,
  adminPanelActivePermissions,
}) => (
  <Routes>
    <Route exact path="/" element={<Home />} />
    <Route
      exact
      path="/users"
      element={
        <AccessControl
          name="Users"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Users'
          )}
        >
          <Users />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/stores"
      element={
        <AccessControl
          name="Stores"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Stores'
          )}
        >
          <Stores />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/stores/:store_id"
      element={
        <AccessControl
          name="Stores"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Stores'
          )}
        >
          <StoreDetails />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/users/:platform_id"
      element={
        <AccessControl
          name="Users"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Users'
          )}
        >
          <User />
        </AccessControl>
      }
    />
    <Route
      path="/priorities"
      element={
        <AccessControl
          name="Priorities"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Priorities'
          )}
        >
          <Priorities />
        </AccessControl>
      }
    />
    <Route
      path="/potd"
      element={
        <AccessControl
          name="Post of the Day"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Post of the Day'
          )}
        >
          <POTD />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/potd/candidates"
      element={
        <AccessControl
          name="Post of the Day"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Post of the Day'
          )}
        >
          <POTDCandidates />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/potd/schedule"
      element={
        <AccessControl
          name="Post of the Day"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Post of the Day'
          )}
        >
          <POTDCreate />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/potd/update"
      element={
        <AccessControl
          name="Post of the Day"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Post of the Day'
          )}
        >
          <POTDEdit />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/videoReviewDashboard"
      element={
        <AccessControl
          name="Video Review"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Decision'
          )}
        >
          <VideoReviewDashboard />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/powerbi"
      element={
        <AccessControl
          name="PowerBI"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'View Video Report'
          )}
        >
          <PowerBI />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/stickers"
      element={
        <AccessControl
          name="Stickers"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Stickers'
          )}
        >
          <Stickers />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/socialChamps"
      element={
        <AccessControl
          name="Social Champs"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Users'
          )}
        >
          <SocialChamps />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/templates/new"
      element={
        <AccessControl
          name="Templates"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Templates'
          )}
        >
          <TemplateFormPage />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/templates/:template_id"
      element={
        <AccessControl
          name="Templates"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Templates'
          )}
        >
          <TemplateFormPage />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/templates"
      element={
        <AccessControl
          name="Templates"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Templates'
          )}
        >
          <Templates />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/storePhotosReview"
      element={
        <AccessControl
          name="Store Photos"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Store Photos'
          )}
        >
          <StorePhotosReview />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/tasks"
      element={
        <AccessControl
          name="Content Requests"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Content Requests'
          )}
        >
          <TasksPage />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/tasks/new"
      element={
        <AccessControl
          name="Content Requests"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Content Requests'
          )}
        >
          <TaskFormPage />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/tasks/:task_id"
      element={
        <AccessControl
          name="Content Requests"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Content Requests'
          )}
        >
          <TaskFormPage />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/alerts"
      element={
        <AccessControl
          name="Alerts"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Alerts'
          )}
        >
          <AlertsPage />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/alerts/new"
      element={
        <AccessControl
          name="Alerts"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Alerts'
          )}
        >
          <AlertFormPage />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/guide"
      element={
        <AccessControl
          name="Field Guide"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'View Field Guide'
          )}
        >
          <Guide />
        </AccessControl>
      }
    />
    <Route
      exact
      path="/fileUpload"
      element={
        <AccessControl
          name="File Upload"
          userPermissions={userPermissions}
          requiredPermission={adminPanelActivePermissions.find(
            (permission) => permission.title === 'Manage Templates'
          )}
        >
          <FileUpload />
        </AccessControl>
      }
    />
  </Routes>
);

AuthenticatedRoutes.propTypes = {
  userPermissions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      active: PropTypes.bool.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      createdAt: PropTypes.string.isRequired,
      updatedAt: PropTypes.string.isRequired,
    })
  ).isRequired,
  adminPanelActivePermissions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      active: PropTypes.bool.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      createdAt: PropTypes.string.isRequired,
      updatedAt: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const UnauthenticatedRoutes = () => (
  <Routes>
    <Route path="/*" element={<LoginPage />} />
    <Route path="/unauthorized" element={<Unauthorized />} />
  </Routes>
);

export default function Layout() {
  const { state } = useContext(UserContext);

  const routes = useMemo(() => {
    if (state.authenticated && !state.userIsLoading) {
      return (
        <AuthenticatedRoutes
          userPermissions={state.userPermissions}
          adminPanelActivePermissions={state.adminPanelActivePermissions}
        />
      );
    }
    if (!state.authenticated && !state.userIsLoading) {
      return <UnauthenticatedRoutes />;
    }
    return (
      <Grid container sx={{ justifyContent: 'center' }}>
        <Grid>
          <SpinningSpark height="50" />
        </Grid>
      </Grid>
    );
  }, [state]);

  return (
    <Box sx={{ display: 'flex' }}>
      {state.authenticated && !state.userIsLoading && <DrawerMenu />}
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Container maxWidth={false}>{routes}</Container>
      </Box>
    </Box>
  );
}
